import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const APPLIED_TAX_SCHEMA = Object.freeze({
    TAX_ID: '',
    RATE: 0,
  }),
  RECORD = generateSchema(APPLIED_TAX_SCHEMA),
  KEYS: any = generateKeys(APPLIED_TAX_SCHEMA);

export class AppliedTax extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get taxId(): string {
    return this.get(KEYS.TAX_ID);
  }

  get rate(): number {
    return this.get(KEYS.RATE);
  }
}
